module.exports = __webpack_public_path__ + "img/partner2.0dd35c9b.jpg";